module.exports = __webpack_public_path__ + "static/img/loading_baidi.c61659b6.gif";